/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { ISzfCategoryDetailsViewProps } from './szf-category-details';
import { Text } from '@msdyn365-commerce/core';
import { TextValueTranslation } from '@msdyn365-commerce/retail-proxy';
import { EventSchedule } from './components/event-schedule';
import { renderImageUrls } from '../../utilities/imageUtils';
import { ILinksData } from './szf-category-details.props.autogenerated';
import SZFModal from '../../utilities/szf-modal.component';
import { ImageGallery } from '../../utilities/image-gallery.component';
import { TimeSVG, DateSVG } from '../../utilities/icons';

export default (props: ISzfCategoryDetailsViewProps) => {
    const {
        data: { categoryDetails },
        config: {
            className,
            imageModalHeading,
            maxImagesToShow,
            categoryDetailHeading,
            links,
            eventDateHeading,
            eventTimeHeading,
        },
        context: {
            request: {
                locale,
                apiSettings: { baseImageUrl },
                textDirection
            }
        },
        resources: {
            bookNowText,
        }
    } = props;
    
    const subCategoryDetails = categoryDetails.result?.categoryDetails;
    const parentCategoryRecordId = props.context.app.config.hideButtonsOnClpAndCdp;
    const parentCategoryId = categoryDetails.result?.categoryDetails?.ParentCategory === parentCategoryRecordId;
    const imageBaseURL = baseImageUrl?.substring(0, baseImageUrl?.length - 1);
    const [isOpenModal, setIsOpenModal] = React.useState<boolean>(false);
    const toggleModal = () => {
        setIsOpenModal(!isOpenModal);
    };
    const images = renderImageUrls(imageBaseURL, subCategoryDetails, maxImagesToShow! || 12);
    const eventSchedule = subCategoryDetails?.LocalizedDescription?.split('__')[1]!;
    const time = eventSchedule?.split('--')![0];
    const date = eventSchedule?.split('--')![1];
    const RegisterButtonSlots = props.slots && props.slots.tefanRegistrationButton && props.slots.tefanRegistrationButton.length > 0 ? props.slots.tefanRegistrationButton : [];
    // const categoryId = categoryDetails.result?.categoryDetails?.RecordId.toString();

    // if (categoryId && tefanCategoryOptionsData) {
    //     const crjmMatchCategoryFound = tefanCategoryOptionsData.find(categoryOptionsItem => categoryOptionsItem?.szf_hqid === categoryId);
    //     state.categoryId = crjmMatchCategoryFound?.szf_tefanalawwalcategoryid!;
    // }
    const renderRegistrationButtonSlots = ()=>{
        return RegisterButtonSlots.map((RegisterButtonSlot,i)=>{
            return(
                <div key={`tefan-awal-registration-button-${i}`}>
                    {RegisterButtonSlot}
                </div>
            )
        })
    }
    return (
        <>
            <div className={`${className}__banner-container`}>
                <div className={`${className}__banner`}>
                    <img
                        src={`${imageBaseURL}${subCategoryDetails?.Name?.replace('&', 'And')
                            .replace(/\b(?<!')[a-z]/g, match => match.toUpperCase())
                            .replace(',', '')}__CDP__000.jpg`}
                    />
                </div>
                <div className={`${className}__banner-title`}>
                    <Text
                        tag='h2'
                        text={`${subCategoryDetails?.NameTranslations?.find((item: TextValueTranslation) =>
                            item.Language?.toLowerCase().includes(locale.toLowerCase())
                        )?.Text?.toUpperCase()}`}
                    />
                </div>
            </div>
            <div className={`${className}__main-container`}>
                <div className={`${className}__image-container`}>
                    <div className='row'>
                        <div className='col-12 col-sm-12 col-md-12 col-lg-8'>
                            <div className='image-main-container'>
                                <div className='image1Container'>
                                    <img
                                        src={`${imageBaseURL}${subCategoryDetails?.Name?.replace('&', 'And')
                                            .replace(/\b(?<!')[a-z]/g, match => match.toUpperCase())
                                            .replace(',', '')}__CDP__001.jpg`}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className='col-12 col-sm-12 col-md-12 col-lg-4'>
                            <div className='row'>
                                <div className='col-12 col-sm-6 col-md-6 col-lg-12'>
                                    <div className='image-main-container'>
                                        <div className='image2Container'>
                                            <img
                                                src={`${imageBaseURL}${subCategoryDetails?.Name?.replace('&', 'And')
                                                    .replace(/\b(?<!')[a-z]/g, match => match.toUpperCase())
                                                    .replace(',', '')}__CDP__002.jpg`}
                                                alt=''
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className='col-12 col-sm-6 col-md-6 col-lg-12'>
                                    <div className='image-main-container'>
                                        <div className='image3Container'>
                                            <img
                                                src={`${imageBaseURL}${subCategoryDetails?.Name?.replace('&', 'And')
                                                    .replace(/\b(?<!')[a-z]/g, match => match.toUpperCase())
                                                    .replace(',', '')}__CDP__003.jpg`}
                                                alt=''
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={`${className}__content`}>
                    <h2 className={`${className}__title`}>{categoryDetailHeading?.toUpperCase()}</h2>
                    <p className={`${className}__description`}>{`${subCategoryDetails?.LocalizedDescription?.split('__')[0]}`}</p>
                    <div className={`${className}__button-container`}>
                        {!parentCategoryId
                            ? links?.map((link: ILinksData) => {
                                  return (
                                      <button
                                          key={link.linkText}
                                          className={`${className}__${link.linkText?.replace(' ', '-').toLowerCase()}-button`}
                                          onClick={() => {
                                              bookNowText !== link.linkText
                                                  ? toggleModal()
                                                  : (window.location.href = `${link.linkUrl.destinationUrl}`);
                                          }}
                                      >
                                          <a href='javascript:;'>{link.linkText}</a>
                                      </button>
                                  );
                              })
                            : ''}
                    </div>
                </div>
                {parentCategoryId &&
                    <div className='competition-register-btn-container'>
                        {renderRegistrationButtonSlots()}
                    </div>
                }
                <div className={`${className}__event-schedule-container`}>
                    <EventSchedule
                        {...{
                            baseClassName: className!,
                            imageSVG: <TimeSVG />,
                            text: `${eventTimeHeading || 'Start Time'}`,
                            time: `${time || '4-PM'}`
                        }}
                    />
                    <EventSchedule
                        {...{
                            baseClassName: className!,
                            imageSVG: <DateSVG />,
                            text: `${eventDateHeading || 'Event Date'}`,
                            date: `${date || '31,Dec 2022'}`
                        }}
                    />
                </div>
            </div>
            {!parentCategoryId ? (
                <div className={`${className}__modal-container`}>
                    <SZFModal
                        isOpen={isOpenModal}
                        onModalToggle={toggleModal}
                        className={'images-modal'}
                        modalTitle={
                            <>
                                <h3>{imageModalHeading}</h3>
                                <button onClick={toggleModal} className='modal-close-btn'>
                                    <img src='https://images-ap-prod.cms.commerce.dynamics.com/cms/api/rwrswxpkjb/imageFileData/MB2GuE?pubver=0' />
                                </button>
                            </>
                        }
                        modalBody={<ImageGallery className={className!} images={images} textDirection={textDirection} />}
                    />
                </div>
            ) : (
                ''
            )}
        </>
    );
};
